import React from 'react';
import { Box, Chip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PatientDocument, PatientDocumentType } from '@uplift/api';
import { usePatientDocumentsQuery } from '@uplift/queries';
import { Button } from '../../../../../Button';
import { PatientProfileInfoAccordion } from '../PatientProfileInfoAccordion';
import { DocumentCard } from './DocumentCard.component';


const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));


export type DocumentsAccordionProps = {
  patientId: string;
  onViewAllDocuments?: () => void;
  onSelect?: (document: PatientDocument) => void;
};


export const DocumentsAccordion: React.VFC<DocumentsAccordionProps> = (props) => {
  const { classes } = useStyles();
  const { data: { documents = [], allDocumentsCount } = {} } = usePatientDocumentsQuery(props.patientId, [ PatientDocumentType.static, PatientDocumentType.form ], { suspense: true });

  return (
    <PatientProfileInfoAccordion
      title="Documents"
      chip={(
        <Chip size="small" label={allDocumentsCount ?? 0} />
      )}
    >
      {documents?.length ? (
        <Box className={classes.root}>
          {documents.map(document => (
            <DocumentCard
              key={document.uploadedAt}
              document={document}
              onSelect={props.onSelect}
            />
          ))}
          {props?.onViewAllDocuments && (
            <Button color="secondary" onClick={() => props.onViewAllDocuments?.()}>
              View all documents
            </Button>
          )}
        </Box>
      ) : null}
    </PatientProfileInfoAccordion>
  );
};
